export default __webpack_public_path__ + "static/media/daughter-giving-gift-to-father.17f8e98f.jpg";